/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Otp_VerifyingInputs */

const he_auth_otp_verifying = /** @type {(inputs: Auth_Otp_VerifyingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`מאמת קוד...`)
};

const en_auth_otp_verifying = /** @type {(inputs: Auth_Otp_VerifyingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verifying code...`)
};

/**
* | output |
* | --- |
* | "Verifying code..." |
*
* @param {Auth_Otp_VerifyingInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const auth_otp_verifying = /** @type {((inputs?: Auth_Otp_VerifyingInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Otp_VerifyingInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_auth_otp_verifying(inputs)
	return en_auth_otp_verifying(inputs)
});